import { put, call } from "redux-saga/effects";
import {
    getComplaintsSuccessAction,
    getComplaintsFailureAction,
    getRisksSuccessAction,
    getRisksFailureAction
} from "../actions/hospitalActions";
import { END_POINTS } from "../../api/endpoints";
import { API } from "../../api/api";

// ------ get complaint list ------

export function* getComplaintList(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const complaintsResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.getComplaintList}`
    );

    if (!complaintsResponse.success) {
      throw new Error(complaintsResponse.message);
    }
    yield put(getComplaintsSuccessAction(complaintsResponse.data));
  } catch (error) {
    yield put(getComplaintsFailureAction(error.message));
  }
}

//  --- get risk list 

export function* getRiskList(action) {
  try {
    let baseUrl =
      process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEVELOP
        : process.env.REACT_APP_PROD;
    const riskResponse = yield call(
      API.get,
      `${baseUrl}${END_POINTS.getRiskList}`
    );

    if (!riskResponse.success) {
      throw new Error(riskResponse.message);
    }
    yield put(getRisksSuccessAction(riskResponse.data));
  } catch (error) {
    yield put(getRisksFailureAction(error.message));
  }
}
